import React, { useState } from 'react';
import { Modal, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';

import { api } from 'api';
import { getErrorMessage } from 'helpers/feedbackMessageHelper';

const JoinLeagueModal = ({ open, onClose }) => {

    const navigate = useNavigate();

    const [joinCode, setJoinCode] = useState('');
    const [joining, setJoining] = useState(false);

    const handleJoinLeague = async () => {
        setJoining(true);
        try {
            const response = await api.user.joinMiniLeague(joinCode);
            onClose();
            setJoinCode('');
            message.success('Joined league successfully');
            navigate(`/team-standings/${response.data.id}`);
        } catch (error) {
            const errorMessage = error.response ? error.response.data.error : 'generic';
            message.error(getErrorMessage(errorMessage));
        }
        setJoining(false);
    };

    const handleCancel = () => {
        onClose();
        setJoinCode('');
    };

    return (
        <Modal
            title="Join a League"
            open={open}
            onCancel={handleCancel}
            onOk={handleJoinLeague}
            okText="Join"
            confirmLoading={joining}
            okButtonProps={{ disabled: !joinCode.trim() || joinCode.trim().length < 6 }}
        >
            <Input
                placeholder="Enter league code"
                value={joinCode}
                onChange={e => setJoinCode(e.target.value)}
                onPressEnter={handleJoinLeague}
            />
        </Modal>
    );
};

export default JoinLeagueModal;
